module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/4_08566f11c9a72939d04e3f77a7b66398.png";